export const AddMetadataRenderItemFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataRenderItem' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'uiWidgetHint' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddMetadataLabelFragment' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddMetadataSelectSelection' } },
                    { kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddMetadataDistinctValueSelection' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataLabelFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataSelectSelection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowedValues' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupValues' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMultiSelect' } },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'AddMetadataDistinctValueSelection' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DocumentMetadataProperty' } },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'reference' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'isMultiSelect' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                ],
            },
        },
    ],
};
